<template>
  <basic-container>
    <div style="display: flex;">
      <div class="left" style="width: 300px;">
        <div>
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="视频列表" name="first">
              <el-tree
            default-expand-all
            ref="treeRef"
            node-key="id"
            :data="cameraList"
            :props="treeAreaProps"
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="treeNodeClick"
          >
            <span slot-scope="{ node }" class="custom-tree-node">
              <template>
                <div style="display: flex;justify-content: space-between;">
                  <div
                    style="    width: 200px;
                                overflow-x: hidden;
                                text-overflow: ellipsis;"
                  >
                    {{ node.data.monitorName!=""&&node.data.monitorName!=undefined?node.data.monitorName:node.data.areaName }}
                  </div>
                  <div @click.stop="collect(node.data)"><i class="el-icon-star-off" style="margin-left: 30px;" 
                    v-if="node.data.monitorName!=''&&node.data.monitorName!=undefined"
                  :class="{
                    'activeCollect': node.data.favoriteFlag==1
                  }"> </i></div>
                </div>
              </template>
            </span>
          </el-tree>
            </el-tab-pane>
            <el-tab-pane label="收藏列表" name="second">
              <el-tree
            default-expand-all
            ref="treeRef2"
            node-key="id"
            :data="favoriteList"
            :props="treeAreaProps"
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="favoritetreeNodeClick"
          >
            <span slot-scope="{ node }" class="custom-tree-node">
              <template>
                <div style="display: flex;justify-content: space-between;">
                  <div
                    style="    width: 200px;
                                overflow-x: hidden;
                                text-overflow: ellipsis;"
                  >
                    {{ node.data.monitorName!=""&&node.data.monitorName!=undefined?node.data.monitorName:node.data.areaName }}
                  </div>
                  <div @click.stop="collect(node.data)"><i class="el-icon-star-off" style="margin-left: 30px;" 
                    v-if="node.data.monitorName!=''&&node.data.monitorName!=undefined"
                  :class="{
                    'activeCollect': node.data.favoriteFlag==1
                  }"> </i></div>
                </div>
              </template>
            </span>
          </el-tree>
            </el-tab-pane>
          
          </el-tabs>
          
        </div>
      </div>
      <div v-if="activeName=='first'" class="right" :style="`height: ${bodyHeight - 130}px;flex:1;overflow: scroll;`">
       
        <div class="liveBody" style="text-align: center;">
          <div class="live" v-for="(item, index) in cameraUrlList" :key="index">
            <player :videoUrl="item" fluent autoplay @screenshot="shot" @destroy="destroy" />
          </div>
        </div>
        <div class="right_bottom">
          <el-pagination
            layout="prev, pager, next"
            :page-size="9"
            @current-change="handleCurrentChange"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
      <div  v-if="activeName=='second'" class="right" :style="`height: ${bodyHeight - 130}px;flex:1;overflow: scroll;`">
       
       <div class="liveBody" style="text-align: center;">
         <div class="live" v-for="(item, index) in favoritecameraUrlList" :key="index">
           <player :videoUrl="item" fluent autoplay @screenshot="shot" @destroy="destroy" />
         </div>
       </div>
       <div class="right_bottom">
         <el-pagination
           layout="prev, pager, next"
           :page-size="9"
           @current-change="favoritehandleCurrentChange"
           :total="favoritePage.total"
         >
         </el-pagination>
       </div>
     </div>
    </div>
  </basic-container>
</template>
<script>
import { mapGetters } from 'vuex';
import { videoareatree,monitorvideoareapage,monitorvideofavorite ,favoritelist,monitorvideofavoritepage} from '@/api/call-system/video';
import { getCameraList } from '@/api/nursingHome/security.js';
import player from '@/views/nursingHome/components/jessibuca.vue';

export default {
  components: { player },
  data() {
    return {
      activeName:'first',
      treeAreaProps: {
        label: 'monitorName',
        value: 'id',
        children: 'videoList',
      },
      favoriteList:[],
      
      favoritePage:{
        current:1,
        size:9,
        total:0
      },
      page:{
        current:1,
        size:9,
        total:0
      },
      rowInfo: {},
      nursinghomeList: [],
      searchForm: {
        name: '',
        nursinghomeId: '',
        cameraId: '',
      },
      accumulateEnergyUseShowList: [],
      nowEnergyUsingDataShowList: [],
      projectList: [],
      currentAraeId:'',
      favoritecurrentAraeId:'',
      loading: false,
      cameraUrlList: [],
      favoritecameraUrlList:[],
      currentCameraUrlList: [],
      cameraList: [
        
      ],
    };
  },
  created() {
    this.initData();
    console.log('-------');
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        instantData_chart_line: {},
      };
    },
  },
  mounted() {
    console.log('-------', this.bodyHeight);
  },
  activated() {},
  methods: {
    handleClick(data) {
      if(this.activeName!='first'){
        console.log("asd")
        favoritelist().then(res=>{
          this.favoriteList = res.data
          this.$nextTick(() => {
          setTimeout(() => {
          if(this.favoriteList.length>0){
            this.$refs.treeRef2.setCurrentKey(this.favoriteList[0].id);
            this.favoritetreeNodeClick(this.favoriteList[0]);
          }
          });
         })
        })
      }else{
        this.initData() // 刷新下拉列表数据
      }
    },
    collect(data){
     
      monitorvideofavorite({
        favoriteFlag:data.favoriteFlag==0?1:0,
        id:data.id
      }).then(res=>{
        data.favoriteFlag = data.favoriteFlag==0?data.favoriteFlag=1:data.favoriteFlag=0
      })
    },
    searchClear() {
      this.searchForm.name = '';
    },
    searchRecord() {
      this.cameraUrlList = [];
      this.currentCameraUrlList = [];
      this.initCameraTree();
    },
    initCameraTree() {
      
    },
    handleCurrentChange(val) {
      console.log('----', val);
     this.page.current = val
     this.getVideoPage( this.currentAraeId)
    },
    favoritehandleCurrentChange(val) {
      console.log('----', val);
     this.favoritePage.current = val
     this.getVideoPage( this.favoritecurrentAraeId)
    },
    initData() {
      this.cameraUrlList =[]
      videoareatree().then(res=>{
        this.cameraList= res.data
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.treeRef.setCurrentKey(this.cameraList[0].id);
            this.treeNodeClick(this.cameraList[0]);
          });
         })
        // res.data.forEach((item)=>{
        //   this.cameraUrlList.push(item.url)
        // })
      })
    },

    treeNodeClick(data, node) {
      if(data.monitorName!=""&&data.monitorName!=undefined){
        
        this.cameraUrlList=[]
        this.cameraUrlList.push(data.url)
        this.page.total=1
      }else{
        this.currentAraeId=data.areaId
        this.getVideoPage(data.areaId)
      }
       console.log(data);
      // this.cameraUrlList = [];
      // this.currentCameraUrlList = [];
      // this.cameraUrlList.push(data.url);
      //   this.handleCurrentChange(1);
    },
    favoritetreeNodeClick(data, node) {
      if(data.monitorName!=""&&data.monitorName!=undefined){
        
        this.favoritecameraUrlList=[]
        this.favoritecameraUrlList.push(data.url)
        this.favoritePage.total=1
      }else{
        this.favoritecurrentAraeId=data.areaId
        this.getFavoriteVideoPage(data.areaId)
      }
       console.log(data);
      // this.cameraUrlList = [];
      // this.currentCameraUrlList = [];
      // this.cameraUrlList.push(data.url);
      //   this.handleCurrentChange(1);
    },
    getData() {},
    getVideoPage(areaId) {
      monitorvideoareapage({
        areaId:areaId,
        ...this.page
      }).then(res=>{
        this.cameraUrlList=[]
      res.data.records.forEach(item => {
        this.cameraUrlList.push(item.url);
        });
        this.page.total = res.data.total
      })
    },
    getFavoriteVideoPage(areaId) {
      monitorvideofavoritepage({
        areaId:areaId,
        ...this.favoritePage
      }).then(res=>{
        this.favoritecameraUrlList=[]
      res.data.records.forEach(item => {
        this.favoritecameraUrlList.push(item.url);
        });
        this.favoritePage.total = res.data.total
      })
    },
    initOption() {},
  },
};
</script>

<style scoped>

.activeCollect{
  color: rgb(255, 0, 0);
 
}
.cardStyle {
  border: 1px solid #000;
  padding: 10px 25px;
}
.dataClass {
  font-size: 15px;
}
.cardBody {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-column-gap: 20px;
}
.liveBody {
  display: grid;

  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  grid-template-rows: repeat(3, 1fr);
}
.live {
  border: 1px solid #000; /* 设置网格线条颜色 */
  height: 100%;
  width: 100%;
  background: #000;
  display: flex;
  align-items: center;
}
</style>
